module.exports = __webpack_public_path__ + "img/ch-hotline-ic.dcf6c0be.svg";